import React, { Component } from 'react'
import { Layout as AppLayout } from 'antd'
import Header from './Header'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { connect } from 'react-redux'
import history from 'lib/history'
import localeTh from 'antd/es/locale/th_TH'
import localeEn from 'antd/es/locale/en_US'
import * as authActions from 'modules/auth/actions'
import * as uiActions from 'modules/ui/actions'
import loadable from '@loadable/component'
import { Redirect } from 'react-router-dom'
import PrivateRoute from '../PrivateRoute'

const AlertDashboard = loadable(() =>
  import('modules/logistic-command-center/alert-dashboard/components/Overview'),
)
const TopVehicle = loadable(() =>
  import('modules/logistic-command-center/top-vehicle/components/Overview'),
)
const Config = loadable(() =>
  import('modules/logistic-command-center/event-config/components/Overview'),
)

const Livestream = loadable(() =>
  import('modules/logistic-command-center/livestream/components/Overview'),
)

const InfographicMap = loadable(() =>
  import('modules/logistic-command-center/InfographicMap/components/Overview'),
)
const ManualChoice = loadable(() =>
  import('modules/logistic-command-center/manual-choice/components/Overview'),
)
class Layout extends Component {
  state = {
    pageReload: false,
    notiCount: 0,
    haveNewNoti: false,
    i18n: i18n.th,
    langBtn: 'th',
    checkSelectLang: '',
    url: '',
  }

  changeLang = inputLng => {
    this.setState(
      {
        i18n: i18n[inputLng],
        langBtn: inputLng,
      },
      () => {
        this.props.setLanguageChange(inputLng)
      },
    )
  }

  checkPageReload() {
    if (window.performance) {
      if (
        window.performance.navigation.type == 1 &&
        history.action === 'POP' &&
        history.location.pathname !== '/' &&
        !history.location.pathname.includes('/center_pool/detail')
      ) {
        this.setState({ pageReload: true })
      }
    }
  }

  componentDidMount() {
    this.props.loadCredentials()

    this.checkPageReload()

    const url = new URL(window.location.href)

    this.setState({
      url: url.pathname.substring(18, -1),
    })
  }

  setMsg = (title, msg) => this.props.setFlashMessage(title, msg)

  langMap = {
    th: localeTh,
    en: localeEn,
  }

  render() {
    return (
      <LangContext.Provider value={this.state.i18n}>
        <AppLayout>
          <AppLayout style={{ minHeight: `${window.innerHeight - 25}px` }}>
            <Header
              langBtn={this.state.langBtn}
              changeLang={this.changeLang}
              checkSelectLang={this.state.checkSelectLang}
            />
            <PrivateRoute
              key="/logistic-command-center/alert-dashboard"
              path="/logistic-command-center/alert-dashboard"
              component={props => <AlertDashboard {...props} />}
              done={this.props.done}
            />
            <PrivateRoute
              key="/logistic-command-center/top-vehicle"
              path="/logistic-command-center/top-vehicle"
              component={props =>
                this.props.profile.company_id === 54 ? (
                  <TopVehicle {...props} />
                ) : (
                  <Redirect to="/" />
                )
              }
              done={this.props.done}
            />
            <PrivateRoute
              key="/logistic-command-center/config"
              path="/logistic-command-center/config"
              component={props => <Config {...props} />}
              done={this.props.done}
            />
            <PrivateRoute
              key="/logistic-command-center/livestream"
              path="/logistic-command-center/livestream"
              component={props => <Livestream {...props} />}
              done={this.props.done}
            />

            <PrivateRoute
              key="/logistic-command-center/infographic-map"
              path="/logistic-command-center/infographic-map"
              component={props => <InfographicMap {...props} />}
              done={this.props.done}
            />
            <PrivateRoute
              key="/logistic-command-center/manual-choice"
              path="/logistic-command-center/manual-choice"
              component={props => <ManualChoice {...props} />}
              done={this.props.done}
            />
          </AppLayout>
        </AppLayout>
      </LangContext.Provider>
    )
  }
}

const mapStateToProps = ({
  auth: { accessToken, done, profile, tokenExp },
  ui: { flash, language },
}) => ({
  accessToken,
  done,
  profile,
  flash,
  tokenExp,
  language,
})
const mapDispatchToProps = {
  loadCredentials: authActions.loadCredentials,
  setLanguageChange: uiActions.setLanguageChange,
  setFlashMessage: uiActions.setFlashMessage,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
